import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import hello from "./helloconfig";
import vueClipboards from "vue-clipboards";
// import Ads from 'vue-google-adsense'
import VueAdsense from 'vue-adsense'
// import VueTimeago from 'vue-timeago'
import VS2 from 'vue-script2'
Vue.use(require('vue-script2'))
// Vue.use(Ads.Adsense)
Vue.use(VS2)
Vue.component('adsense', VueAdsense)
// Vue.use(VueTimeago, {
//     name: 'timeago', // component name, `timeago` by default
//     locale: 'sv',
//     // locales: {
//     //   // you will need json-loader in webpack 1
//     //   'sv': require('date-fns/locale/sv.json')
//     // }
//   })

Vue.use(vueClipboards);
Vue.config.productionTip = false;
Vue.use(hello);

if (localStorage.token) {
    store.getters.isLoggedIn = true;
}
new Vue({
    router,
    vuetify,
    hello,
    el: "#app",
    render: h => h(App)
}).$mount("#app");
